import moment from 'moment';

export const convertToLocalTime = (momentObj) => {
  const utcOffset = new Date().getTimezoneOffset() / 60;
  return momentObj.subtract(utcOffset, 'hours');
};
